import { MAX_ATTACHMENT_SIZE_BYTES } from "./constants";

/** Result of validating a file that is a candidate for attachment. */
export type AttachmentValidation = { ok: true } | { ok: false; reason: "empty" | "too-large" };

/**
 * Platform-agnostic pure validation of a file BEFORE uploading it as an
 * attachment (invoice/manual/document). It runs on the client to provide immediate
 * feedback and avoid large requests that the backend would reject anyway. It takes
 * only `size` so it is trivially testable and reusable on web/native.
 */
export function validateAttachmentFile(
  file: { size: number },
  maxBytes: number = MAX_ATTACHMENT_SIZE_BYTES,
): AttachmentValidation {
  if (file.size <= 0) {
    return { ok: false, reason: "empty" };
  }
  if (file.size > maxBytes) {
    return { ok: false, reason: "too-large" };
  }
  return { ok: true };
}
